import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={11 * (props.wx ?? 1)}
    height={26 * (props.hx ?? 1)}
    viewBox="0 0 11 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M9.3791 19.164C9.33394 18.8699 9.25838 18.2584 8.98992 17.6966C8.72779 17.1485 8.47453 16.9672 8.38335 16.3779C7.88949 13.1957 7.99247 12.6865 6.95113 8.87791C6.25845 6.34404 5.54521 1.46664 5.05768 1.3779C4.51654 1.2795 4.11171 6.06554 4.05768 8.8779C3.55768 12.7169 2.43401 13.8414 2.24364 16.2825C2.15415 17.4328 2.15437 17.6791 2.05771 17.9832C1.97498 18.2439 1.58303 18.5424 1.54884 18.8822C1.4336 20.0206 1.45936 22.3347 1.55771 23.9262C1.61512 24.8578 1.7523 25.2391 2.50069 25.3C4.11315 25.4311 7.50537 25.3917 8.95151 25.2195C9.47281 25.1574 9.5184 24.821 9.53275 24.2058C9.56694 22.7068 9.60071 20.6044 9.3791 19.164Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgNormal;
